import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { ConstructionIcon, XIcon } from "lucide-react";
import { useState } from "react";

const UNDER_CONSTRUCTION_DISMISSED_COOKIE = "under_construction_dismissed";
const UNDER_CONSTRUCTION_COOKIE_MAX_AGE = 60 * 60 * 24 * 30;

const isBannerDismissed = () => {
	if (typeof document === "undefined") return false;

	return document.cookie
		.split(";")
		.map((cookie) => cookie.trim())
		.some(
			(cookie) =>
				cookie.startsWith(`${UNDER_CONSTRUCTION_DISMISSED_COOKIE}=`) &&
				cookie.slice(UNDER_CONSTRUCTION_DISMISSED_COOKIE.length + 1) === "1",
		);
};

const setBannerDismissedCookie = () => {
	if (typeof document === "undefined") return;

	document.cookie = `${UNDER_CONSTRUCTION_DISMISSED_COOKIE}=1; Max-Age=${UNDER_CONSTRUCTION_COOKIE_MAX_AGE}; Path=/; SameSite=Lax`;
};

interface UnderConstructionProps {
	className?: string;
}
export const UnderConstruction = ({ className }: UnderConstructionProps) => {
	const [dismissed, setDismissed] = useState(isBannerDismissed);

	if (dismissed) return null;

	return (
		<div
			className={cn(
				"flex items-center gap-4 p-2 border border-amber-500 text-amber-500 bg-[repeating-linear-gradient(135deg,rgba(245,158,11,0.08)_0,rgba(245,158,11,0.08)_8px,rgba(245,158,11,0.18)_8px,rgba(245,158,11,0.18)_16px)]",
				className,
			)}
		>
			<div className="flex items-center gap-4 min-w-0 flex-1">
				<ConstructionIcon className="size-6" />
				<h1 className="tracking-tight">Under Construction</h1>
			</div>
			<Button
				type="button"
				size="icon"
				variant="ghost"
				className="text-amber-500 hover:bg-amber-500/10 hover:text-amber-500"
				aria-label="Dismiss under construction banner"
				onClick={() => {
					setBannerDismissedCookie();
					setDismissed(true);
				}}
			>
				<XIcon className="size-4" />
			</Button>
		</div>
	);
};
